import { Box, Container, Typography } from "@mui/material";
import { useAppTranslation } from "../../../../hooks/useAppTranslation";
import Title from "../../../../common/title/title.components";
import Description from "../../../../common/description/description.components";
import StyledWrapper from "./about-ted-section.styles";

const AboutTed = () => {
  const { t } = useAppTranslation();
  return (
    <StyledWrapper>
      <Container className="about-tedx-content-container">
        <Box className="about-tedx-content">
          <Title className="about-tedx-title" text={t("aboutTedx.title")} />
          <Typography variant="mainBlack" className="about-tedx-subtitle">
            {t("aboutTedx.subTitle")}
          </Typography>
          <Description className="about-tedx-description" text={t("aboutTedx.description")} />
        </Box>
      </Container>
    </StyledWrapper>
  );
};

export default AboutTed;
